/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        buttonGroup: {
            height: {
                value: "40px",
                type: "dimension",
            },
            borderWidth: {
                value: "1px",
                type: "dimension",
            },
            borderRadius: {
                value: "2px",
                type: "dimension",
            },
            paddingHorizontal: {
                value: "16px",
                type: "dimension",
            },
            gap: {
                value: "12px",
                type: "dimension",
            },
            secondary: {
                borderColor: {
                    value: "#949494",
                    type: "color",
                },
                default: {
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#94949429",
                        type: "color",
                    },
                    color: {
                        value: "#364262",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    color: {
                        value: "#252C44",
                        type: "color",
                    },
                    borderColor: {
                        value: "#252C44",
                        type: "color",
                    },
                },
                disabled: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                    borderColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
                selected: {
                    default: {
                        backgroundColor: {
                            value: "#94949452",
                            type: "color",
                        },
                        color: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#94949429",
                            type: "color",
                        },
                        color: {
                            value: "#364262",
                            type: "color",
                        },
                    },
                    active: {
                        backgroundColor: {
                            value: "#94949400",
                            type: "color",
                        },
                        color: {
                            value: "#252C44",
                            type: "color",
                        },
                        borderColor: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                    disabled: {
                        backgroundColor: {
                            value: "#94949429",
                            type: "color",
                        },
                        color: {
                            value: "#b3b3b3",
                            type: "color",
                        },
                    },
                },
            },
            primary: {
                borderColor: {
                    value: "#455D82",
                    type: "color",
                },
                default: {
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    borderColor: {
                        value: "#455D82",
                        type: "color",
                    },
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#94949429",
                        type: "color",
                    },
                    borderColor: {
                        value: "#364262",
                        type: "color",
                    },
                    color: {
                        value: "#364262",
                        type: "color",
                    },
                },
                active: {
                    borderColor: {
                        value: "#252C44",
                        type: "color",
                    },
                    backgroundColor: {
                        value: "#94949400",
                        type: "color",
                    },
                    color: {
                        value: "#252C44",
                        type: "color",
                    },
                },
                disabled: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                    borderColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
                selected: {
                    default: {
                        backgroundColor: {
                            value: "#455D82",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderRightColor: {
                            value: "#364262",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#364262",
                            type: "color",
                        },
                        borderColor: {
                            value: "#364262",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                    active: {
                        backgroundColor: {
                            value: "#252C44",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderColor: {
                            value: "#252C44",
                            type: "color",
                        },
                    },
                    disabled: {
                        backgroundColor: {
                            value: "#94949429",
                            type: "color",
                        },
                        color: {
                            value: "#b3b3b3",
                            type: "color",
                        },
                    },
                },
            },
            small: {
                height: {
                    value: "32px",
                    type: "dimension",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
            },
            large: {
                height: {
                    value: "56px",
                    type: "dimension",
                },
            },
            focusRing: {
                outlineOffset: {
                    value: "1px",
                    type: "dimension",
                },
                outline: {
                    value: "2px solid #3e95fa",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
